const LangSignUp = {
	"signUp.form._createAccount": ["CREATE AN ACCOUNT", "បង្កើត​គណនី"],
	"signUp.form._passwordRules": [
		"Password must:<br />The length is 8-15 characters. It contains at least 1 uppercase letter, 1 lowercase letter, 1 numeric character and 1 special characters.",
		"លេខ​សម្ងាត់​ត្រូវ​តែ​<br />ចំនួន 8-15 តួ​ យ៉ាង​តិច​ត្រូវ​មាន​អក្សរ​ធំ​1តួ អក្សរ​តូច1តួ លេខ1​តួ និង​សញ្ញា​1តួ",
	],
	"signUp.form._consentAgreementRules": [
		"By clicking this button, I agree to the Starbucks Site&nbsp;",
		"ការ​​​ចុច​ប៊ូតុង​នេះ​ ខ្ញុំ​​យល់​ព្រម​អនុវត្ត​តាម​លក្ខខណ្ឌ​​ផ្សេងៗ​ដែល​បាន​ចែង​នៅ​លើ​គេហទំព័រ​របស់​ Starbucks&nbsp;",
	],
	"signUp.form._termOfUse": ["Terms & Conditions", "លក្ខខណ្ឌ​ផ្សេង​ៗ"],
	"signUp.form.label._consentAgreement": [
		"I do not wish to receive news, special offers and more from Starbucks.",
		"ខ្ញុំ​​មិន​ត្រូវ​ការ​ទទួល​បាន​ព័ត៌មាន​​អំពី​ផលិតផល ​ការ​ផ្តល់​ជូន​ពិសេស​ និង​ព័ត៌មាន​ផ្សេង​ៗ​ទៀត​ពី​ Starbucks ឡើយ ។",
	],
	"signUp.form.name._consentAgreement": ["Consent Agreement", "កិច្ច​ព្រម​ព្រៀង"],
	"signUp.form._Whatisthis": ["What is this?", "តើនេះ​ជា​អ្វី​?"],
	"signUp.form._Scratch": [
		"Scratch off this portion at the back of your card",
		"កោស​បរិវេណ​នេះ​​ នៅ​ខាង​ក្រោយ​កាត​របស់​លោក​អ្នក​",
	],
	"signUp.form._switch": [
		"I have a physical Starbucks Card",
		"ខ្ញុំមានកាតផ្លាស្ទិចរួចហើយ",
	],
	"signUp._switch._desciption": [
		"Upon completing your registration, you will receive a virtual Starbucks Card that can be used to make payment in Starbucks Khmer stores when you log in via the mobile app.",
		"ពេលដែលអ្នកចុះឈ្មោះរួចរាល់ អ្នកនឹងទទួលបានកាតនិម្មិត Starbucks មួយ​ ដើម្បីទូទាត់ជាមួយសាខា Starbucks នៅកម្ពុជាទាំងអស់",
	],
	"signUp._otp._title": [
		"Welcome to <br/> Starbucks Rewards",
		"សូមស្វាគមន៍មកកាន់កម្មវិធី Starbucks Rewards!",
	],
	"signUp._otp._description1": [
		"Verify your mobile number!",
		"សូមធ្វើការបញ្ជាក់លេខទូរសព្ទ! ",
	],
	"signUp._otp._description2": [
		"We has sent an OTP code on your mobile phone number",
		"យើងបានផ្ញើរលេខកូត OTP ទៅលេខទូរសព្ទអ្នកហើយ",
	],
	"signUp._otp._verify": ["Verify", "ផ្ទៀង​ផ្ទាត់"],
	"signUp._register._mobile": ["Register with mobile", "ចុះឈ្មោះជាមួយលេខទូរសព្ទ"],
	"signUp._register._email": ["Register with email", "ចុះឈ្មោះជាមួយអ៊ីម៊ែល"],
	"signUp._email._success.": [
		" Verify your email address to get started! A verification link has been sent to your registered email address, click on the link to complete your registration.<br/><br/> If you do not receive the email within the next few minutes, please check your junk/spam folder.",
		"សូមធ្វើការបញ្ជាក់់អ៊ីម៊ែលរបស់អ្នក! សូមចុចលីង ដែលយើងបានផ្ញើរទៅអ៊ីម៊ែលរបស់អ្នក។ បើអ្នករកមិនឃើញ កុំភ្លេចមើលក្នុង ប្រអប់ junk/spam ផងដែរ ។",
	],
}

export default LangSignUp



// WEBPACK FOOTER //
// ./src/resources/pages/LangSignUp.js